import { Component, Input } from '@angular/core';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-plain-invoice',
  templateUrl: './plain-invoice.component.html',
  styleUrls: ['./plain-invoice.component.scss']
})
export class PlainInvoiceComponent {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';

  constructor(private _globalService: GlobalStateService) { }

  settings: any = null;
  logoUrl: string = '';

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this._globalService.GetSetting().subscribe((res: any) => {
      this.settings = res.contacts?.english;
      this.logoUrl = res.logo || '';
    });
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  formatCurrency(amount: number | null, currency: string | null = 'USD'): string {
    if (!amount || amount === 0) return '-';
    const curr = currency || 'USD';
    return `${curr} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  getVehicleImage(vehicle:any){

    if (vehicle.pictures && vehicle.pictures.length > 0) {
      return vehicle.type=="aucnet"? vehicle.pictures[0] : (vehicle.pictures.length > 1?vehicle.pictures[1]:vehicle.pictures[0]);
    }
    return 'assets/media/stock/600x400/img-1.jpg'; // Fallback image

    // return vehicle?.pictures && vehicle.pictures.length > 0 ? (vehicle.type == "aucnet"?vehicle.pictures[0] : vehicle.pictures[1] ): 'assets/images/no-car-image.png'
  }
}
